package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.DeliveryDraft
import com.milta.feature.route.domain.entity.RouteCreationResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes — creates a route for a driver with its initial deliveries (DOM-02). */
class CreateRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(
        driverAccountId: String,
        deliveries: List<DeliveryDraft>,
        date: String? = null,
        // MIL-99 — Enterprise's loading address (start point of the optimization).
        loadingAddressId: String? = null,
    ): RouteCreationResult = repository.createRoute(driverAccountId, deliveries, date, loadingAddressId)
}
